import React from 'react';
import { Button } from '@mui/material';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

const sizes = [48, 72, 96, 144, 192, 512];

const IconGenerator = ({ image }) => {
    const generateIcons = () => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        const img = new Image();
        img.src = URL.createObjectURL(image);

        img.onload = async () => {
            const zip = new JSZip();
            const folder = zip.folder('icons');

            for (const size of sizes) {
                canvas.width = size;
                canvas.height = size;
                context.drawImage(img, 0, 0, size, size);
                const dataUrl = canvas.toDataURL();
                const base64Data = dataUrl.split(',')[1];
                folder.file(`icon-${size}x${size}.png`, base64Data, { base64: true });
            }

            const content = await zip.generateAsync({ type: 'blob' });
            saveAs(content, 'icons.zip');
        };
    };

    return (
        <div>
            <Button variant="contained" color="primary" onClick={generateIcons}>
                Generate and Download Icons
            </Button>
        </div>
    );
};

export default IconGenerator;
